import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Table, Form, Button, Modal, Typography } from "antd";
import CalenderPicker from "./CalenderPicker";
import { PlusOutlined, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { convertAvailabilityEventsFromCalender } from "../util/helpers";
const { Text } = Typography;
const TableComponent = ({
  value,
  onChange,
  disabled,
  dataSource,
  addText,
  editText,
  tableItems,
  category,
  name,
  emptyImg,
  resource,
  action,
  comp,
  entityId,
  title,
}) => {
  const [columns, setColumns] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!value) {
      onChange([]);
    }
    let tableColumns = [];
    tableItems.forEach(function (item) {
      const title = "app.forms." + category + "." + name + "." + item.title;
      const j = item.render
        ? {
            title: <FormattedMessage id={title} />,
            dataIndex: item.title,
            responsive: item.responsive,
            width: item.width ? item.width : "auto",
            render(text, record, columnProps) {
              const Comp = item.render;
              return (
                <Comp
                  category={category}
                  record={record}
                  text={text}
                  {...item.columnProps}
                />
              );
            },
          }
        : {
            title: <FormattedMessage id={title} />,
            dataIndex: item.title,
            responsive: item.responsive,
            width: item.width ? item.width : "auto",
          };

      tableColumns.push(j);
    });
    tableColumns.push({
      title: (
        <FormattedMessage
          id={"app.forms." + category + "." + name + ".actions"}
        />
      ),
      dataIndex: "actions",
      render: (row, index) => (
        <Button
          type="link"
          onClick={() => {
            onDeleteRow(row, index);
          }}
        >
          <DeleteOutlined style={{ color: "red" }} />
        </Button>
      ),
    });

    setColumns(tableColumns);
  }, [value]);

  const onDeleteRow = (row, item) => {
    var arr = value.filter((entry) => entry.id !== item.id);
    onChange(arr);
  };

  const onAddClick = () => {
    setVisible(true);
  };

  const onDecline = () => {
    setVisible(false);
  };

  const onFinish = (values) => {
    setVisible(false);
    const converted = convertAvailabilityEventsFromCalender(values, entityId);
    onChange(converted);
  };
  return (
    <div>
      <Button
        onClick={onAddClick}
        type="dashed"
        style={{
          marginBottom: "10px",
          display: "flex",
          alignItems: "center",
        }}
        icon={value && value.length > 0 ? <EditOutlined /> : <PlusOutlined />}
      >
        <Text style={{ padding: "0 6px" }}>
          {value && value.length > 0 ? editText : addText}
        </Text>
      </Button>
      {value && value.length > 0 ? (
        <Table
          columns={columns}
          dataSource={value}
          size="small"
          disabled={disabled}
          rowKey={(record) => record.id}
          bordered
        />
      ) : (
        emptyImg
      )}

      <Modal
        closable={false}
        footer={null}
        maskClosable={true}
        title={null}
        width={"90%"}
        styles={{
          body: {
            padding: 0,
          },
        }}
        open={visible}
        destroyOnClose={true}
      >
        <CalenderPicker
          title={title}
          comp={comp}
          record={value}
          onFinish={onFinish}
          onDecline={onDecline}
          onChange={onChange}
        />
      </Modal>
    </div>
  );
};

const CalenderItem = (props) => {
  const {
    name,
    category,
    addText,
    editText,
    tableItems,
    emptyImg,
    resource,
    action,
    comp,
    entityId,
    title,
  } = props;

  return (
    <Form.Item name={name}>
      <TableComponent
        tableItems={tableItems}
        size="small"
        addText={addText}
        editText={editText}
        category={category}
        name={name}
        emptyImg={emptyImg}
        resource={resource}
        action={action}
        comp={comp}
        entityId={entityId}
        title={title}
      />
    </Form.Item>
  );
};

CalenderItem.propTypes = {
  name: PropTypes.string,
  category: PropTypes.string,
  resource: PropTypes.string,
  action: PropTypes.string,
};

export default CalenderItem;
